import { alpha } from '@material-ui/core';
import { palette } from '../../../settings/themes/colors';

const styles = () => ({
  card: {
    maxHeight: '98vh',
    boxSizing: 'border-box',
    overflowY: 'auto'
  },
  section: {
    marginBottom: 4
  },
  sectionTitle: {
    fontWeight: 700,
    color: palette.darkGray,
    marginBottom: 8
  },
  sectionDivider: {
    marginTop: 16,
    marginBottom: 16
  },
  scopeSummary: {
    padding: 12,
    borderRadius: 4,
    backgroundColor: palette.artic
  },
  scopeCount: {
    fontWeight: 600,
    color: palette.darkGray
  },
  scopeCountHint: {
    display: 'block',
    color: palette.dimGray,
    marginBottom: 8
  },
  scopeRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    marginTop: 4
  },
  scopeRowLabel: {
    color: palette.dimGray
  },
  scopeRowValue: {
    fontWeight: 600,
    color: palette.darkGray
  },
  statusChip: {
    borderRadius: 8,
    border: `1px solid ${alpha(palette.dimGray, 0.2)}`,
    color: `${palette.white} !important`,
    fontWeight: 'bold'
  },
  contentOption: {
    alignItems: 'flex-start',
    marginBottom: 4,
    '& .MuiRadio-root': {
      paddingTop: 4
    }
  },
  contentOptionLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    flexWrap: 'wrap'
  },
  contentOptionTitle: {
    fontWeight: 600,
    color: palette.darkGray
  },
  contentOptionHint: {
    display: 'block',
    color: palette.dimGray
  },
  contentOptionDisabledHint: {
    display: 'block',
    marginTop: 2,
    color: palette.dimGray,
    fontStyle: 'italic'
  },
  contentOption_disabled: {
    cursor: 'not-allowed',
    '& $contentOptionTitle': {
      color: palette.silver
    },
    '& $contentOptionHint': {
      color: palette.silver
    }
  },
  preferences: {
    marginTop: 8,
    paddingLeft: 32,
    display: 'flex',
    flexDirection: 'column'
  },
  checkboxRow: {
    marginBottom: 0
  },
  defaultBadge: {
    height: 20,
    fontSize: 11,
    fontWeight: 700,
    color: palette.white,
    backgroundColor: palette.captudataBlue
  },
  formatValue: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    color: palette.darkGray
  },
  formatIcon: {
    color: palette.emerald
  },
  summaryOptions: {
    flexDirection: 'row',
    gap: 24
  },
  helpText: {
    display: 'block',
    marginTop: 6,
    color: palette.dimGray
  },
  infoBox: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 8,
    padding: 12,
    borderRadius: 4,
    backgroundColor: palette.artic,
    color: palette.dimGray
  },
  infoBoxIcon: {
    fontSize: 18,
    color: palette.captudataBlue,
    flexShrink: 0
  },
  infoBoxSpinner: {
    color: palette.captudataBlue,
    flexShrink: 0,
    marginTop: 2
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-start',
    gap: 10,
    marginTop: 24
  },
  statusContainer: {
    textAlign: 'center',
    padding: '20px 0'
  },
  statusIcon: {
    fontSize: 48,
    marginBottom: 12
  },
  statusIcon_completed: {
    color: palette.emerald
  },
  statusIcon_processing: {
    color: palette.captuDataYellow
  },
  statusIcon_error: {
    color: palette.candy
  },
  statusHint: {
    color: palette.dimGray
  }
});

export default styles;
